/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_A1Inputs */

const en_to_csv_faq_a1 = /** @type {(inputs: To_Csv_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An array of objects with consistent keys works best. Each object becomes a row, and each key becomes a column header.`)
};

const ko_to_csv_faq_a1 = /** @type {(inputs: To_Csv_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일관된 키를 가진 객체 배열이 가장 적합합니다. 각 객체는 행이 되고, 각 키는 열 헤더가 됩니다.`)
};

const ja_to_csv_faq_a1 = /** @type {(inputs: To_Csv_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一貫したキーを持つオブジェクト配列が最適です。各オブジェクトが行になり、各キーが列ヘッダーになります。`)
};

/**
* | output |
* | --- |
* | "An array of objects with consistent keys works best. Each object becomes a row, and each key becomes a column header." |
*
* @param {To_Csv_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_a1 = /** @type {((inputs?: To_Csv_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_a1(inputs)
	if (locale === "ko") return ko_to_csv_faq_a1(inputs)
	return ja_to_csv_faq_a1(inputs)
});